import { ContractorField } from "./types";
import * as z from "zod";

export const ContractorFormSchema = z.object({
  [ContractorField.CICPA_ID]: z.string().min(1),
  [ContractorField.TRADE_LICENSE_EXPIRY]: z.date(),
  [ContractorField.TRADE_LICENSE]: z.string().min(1),
  [ContractorField.CONTRACTOR_ARABIC_NAME]: z.string().min(1),
});
